module.exports = __webpack_public_path__ + "static/img/icon20.174aad8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon20.png
// module id = 3LQP
// module chunks = 1